import{defineMessages}from'react-intl';

export default defineMessages({
label:{
id:'select_store.label',
defaultMessage:'Store'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9DcmVhdGVFdmVudFBhZ2UvU2VsZWN0U3RvcmUvU2VsZWN0U3RvcmUubWVzc2FnZXMuanMiXSwibmFtZXMiOlsiZGVmaW5lTWVzc2FnZXMiLCJsYWJlbCIsImlkIiwiZGVmYXVsdE1lc3NhZ2UiXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLE1BQU87QUFDTEMsR0FBSSxvQkFEQztBQUVMQyxlQUFnQixPQUZYLENBRHFCLENBQWYsQ0FBZiIsImZpbGUiOiJTZWxlY3RTdG9yZS5tZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuICBsYWJlbDoge1xuICAgIGlkOiAnc2VsZWN0X3N0b3JlLmxhYmVsJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ1N0b3JlJyxcbiAgfSxcbn0pO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/pages/CreateEventPage/SelectStore/SelectStore.messages.js
// module id = 2058
// module chunks = 0